module.exports = __webpack_public_path__ + "static/img/组 (5).c7cff26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/5/组 (5).jpg
// module id = 8o4A
// module chunks = 1